import { render, staticRenderFns } from "./FieldPortal.vue?vue&type=template&id=494f5bd8&scoped=true"
import script from "./FieldPortal.vue?vue&type=script&lang=js"
export * from "./FieldPortal.vue?vue&type=script&lang=js"
import style0 from "./FieldPortal.vue?vue&type=style&index=0&id=494f5bd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494f5bd8",
  null
  
)

export default component.exports